module.exports = __webpack_public_path__ + "static/img/card-card-2.f69262c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-card-2.jpg
// module id = MlTN
// module chunks = 1